import {
  JobEntityType,
  JobState,
  JobType,
} from '@texas/api/endpoints/jobRecordsApi';
import { normalizeEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { TFunction } from 'i18next';

export function getJobTypeLabel(type: JobType, t: TFunction): string {
  const normalizedType = normalizeEnumNumber(JobType, type, JobType.Test);
  switch (normalizedType) {
    case JobType.SyncProjectsToGarp:
      return t('jobs.types.syncProjects');
    case JobType.AiPrompt:
      return t('jobs.types.aiPrompt');
    case JobType.CreateArticles:
      return t('jobs.types.createArticles');
    case JobType.CopyArticles:
      return t('jobs.types.copyArticles');
    default:
      return t('jobs.types.test');
  }
}

export function getJobStateLabel(state: JobState, t: TFunction): string {
  const normalizedState = normalizeEnumNumber(
    JobState,
    state,
    JobState.Waiting,
  );
  return t(
    `jobs.states.${JobState[normalizedState].toLowerCase()}` as any,
  ) as string;
}

export function getEntityTypeLabel(type: JobEntityType, t: TFunction): string {
  const key = JobEntityType[type];
  return t(
    `jobs.entities.${key.charAt(0).toLowerCase()}${key.slice(1)}` as any,
  ) as string;
}

export function getEntityInitials(type: JobEntityType) {
  const labels: Record<JobEntityType, string> = {
    [JobEntityType.Sample]: 'SA',
    [JobEntityType.ProductApproval]: 'PA',
    [JobEntityType.CompositionGroup]: 'CG',
    [JobEntityType.Variant]: 'VR',
    [JobEntityType.Article]: 'AR',
    [JobEntityType.Concept]: 'CO',
    [JobEntityType.Customer]: 'CU',
    [JobEntityType.Supplier]: 'SU',
    [JobEntityType.Inquiry]: 'IN',
    [JobEntityType.Offer]: 'OF',
  };
  return labels[type];
}

export function getStateColors(state: JobState) {
  const normalizedState = normalizeEnumNumber(
    JobState,
    state,
    JobState.Waiting,
  );
  switch (normalizedState) {
    case JobState.Finished:
      return {
        badgeVariant: 'job-finished',
        bar: 'jobStatus.finishedBar',
      };
    case JobState.Failed:
    case JobState.Cancelled:
      return {
        badgeVariant: 'job-danger',
        bar: 'jobStatus.dangerBar',
      };
    case JobState.Waiting:
      return {
        badgeVariant: 'job-waiting',
        bar: 'jobStatus.waitingBar',
      };
    default:
      return {
        badgeVariant: 'job-running',
        bar: 'jobStatus.runningBar',
      };
  }
}
